import { mapState, mapMutations, mapActions } from 'vuex';
import DropdownFilter from '~/components/DropdownFilter';
import Dropdown from '~/components/Dropdown';
import Loader from '~/components/Loader';
import FormRadio from '~/components/Form/FormRadio';
import Pagination from '~/components/Pagination';
import FiltersBar from '~/components/FiltersBar';
import Filters from '~/components/Filters';

const mixin = type => {
  return {
    components: {
      DropdownFilter,
      Dropdown,
      Loader,
      FormRadio,
      Pagination,
      FiltersBar,
      Filters,
    },
    async fetch() {
      await this.fetchData({ type });
    },
    computed: {
      ...mapState({
        items: state => state.productsFilters[type].items,
        sort: state => state.productsFilters[type].sort,
        pagination: state => state.productsFilters[type].pagination,
      }),
    },
    destroyed() {
      this.resetState({ type });
    },
    methods: {
      ...mapActions({
        fetchData: 'productsFilters/fetchData',
        changeSort: 'productsFilters/changeSort',
        changePagination: 'productsFilters/changePagination',
      }),
      ...mapMutations({
        resetState: 'productsFilters/resetState',
      }),
      changePage(pageNum) {
        this.changePagination({
          type,
          value: { ...this.pagination, offset: (parseInt(pageNum) - 1) * this.pagination.limit },
        });
      },
    },
  };
};

export default mixin;
